import React, { useEffect, useState, forwardRef } from "react";
import Slider from "react-slick";
import SelectHorseScore from "assets/icons/select_horse_score.svg?react";
import heart from "assets/icons/heart.svg";
import heartwhite from "assets/icons/heartwhite.svg";
import SeatSizeIcon from "assets/icons/seat-size.svg?react";
import "./style.css";
import Button from "components/Buttons";
import Gauge from "../Guage/Guage";
import { useLoggedIn } from "stores/auth/authStore";
import ShoppingCartModal from "components/Modal/ShoppingCart";
import Loader from "components/Spinners/Loader";
import CactusSaddleIcon from "assets/icons/cactus_saddleIcon.svg?react";
import { BrandImageOverlay } from "pages/SaddleDetails/sections/ImageGallery";
import { NavLink, useLocation } from "react-router-dom";
import { Modal, useModalStore } from "stores/modal/useModalStore";
import { useBrandDisciplineStore } from "stores/brandDiscipline/useBrandDisciplineStore";
import { useCartStore } from "stores/cart/useCartStore";
import { formatString } from "utils/index";

const CarouselCards = forwardRef(({
  items,
  loading,
  isCactus = false,
  isBillyCook = false,
  selectedHorse,
  selectedHorseStatus,
  onMoreDetailsClick,
  unAuthDetailsClick,
  onAddToCartClick,
  addToCartLoading,
  onFavouriteClick,
  loadingFavorites,
  favouriteSaddleList,
}, ref) => {
  const location = useLocation();
  const isManufacturerLanding = isCactus || isBillyCook;
  const open = useModalStore((s) => s.open);
  const { user, setIsAction } = useLoggedIn();
  /** Cactus/Billy Cook: always show storefront preview when logged out (no horse gate). /buy keeps horse gate for the teaser carousel. */
  const showGuestCarousel =
    !user && (!selectedHorse || isManufacturerLanding);
  const actionState = useBrandDisciplineStore((state) => state.actionState);
  const [size, setSize] = useState({
    width: "200px",
    height: "90px",
  });
  const [, setCurrentSlide] = useState(0);
  const userCartData = useCartStore((s) => s.userCartData);
  const handleRemove = useCartStore((s) => s.handleRemove);
  const removeCartLoading = useCartStore((s) => s.loadingState?.removeCartLoading);
  const loadingItemId = useCartStore((s) => s.loadingItemId);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 639) {
        setSize({ width: "200px", height: "90px" });
      } else {
        setSize({ width: "155px", height: "90px" });
      }
    };

    window.addEventListener("resize", handleResize);

    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const settings = {
    className: "center",
    centerMode: items?.length >= 3,
    infinite: items?.length >= 3,
    centerPadding: "60px",
    arrows: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    beforeChange: (oldIndex, newIndex) => {
      setCurrentSlide(newIndex);
    },
    speed: 500,
    variableWidth: true,
    autoplay: true,
    responsive: [
      {
        breakpoint: 1536,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          variableWidth: true,
          infinite: items?.length >= 3,
          centerMode: items?.length >= 3,
          className: "center",
        },
      },
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          variableWidth: true,
          centerMode: items?.length >= 3,
          infinite: items?.length >= 3,
          className: "center",
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: items?.length >= 3,
          centerMode: items?.length >= 3,
          className: "center",
          variableWidth: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: items?.length >= 3,
          centerMode: items?.length >= 3,
          className: "center",
          variableWidth: true,
          autoplay: false,
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: items?.length >= 3,
          centerMode: items?.length >= 3,
          className: "center",
          variableWidth: true,
          autoplay: false,
        },
      },
      {
        breakpoint: 400,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: items?.length >= 3,
          centerMode: items?.length >= 3,
          className: "center",
          variableWidth: true,
          autoplay: false,
        },
      },
    ],
  };

  const handleSelectHorse = () => {
    try {
      if (!user) {
        open(Modal.Login);
        return;
      }

      switch (location.pathname) {
        case "/cactus":
        case "/billy-cook":
          setIsAction("createHorse");
          break;
        case "/buy":
          setIsAction("selectBuyProduct");
          break;
        default:
          console.warn("No action for this path");
      }
    } catch (error) {
      console.error("An error occurred in handleSelectHorse:", error);
    }
  };

  const manufacturerBrandPath = (brandName) => {
    const bn = (brandName || "").toLowerCase();
    if (bn.includes("cactus")) return "/cactus";
    if (bn.includes("billy")) return "/billy-cook";
    return "";
  };

  const formatManufacturerTitle = (title) => {
    const raw = title || "Rancher";
    const stripped = raw
      .replace(/\bCactus\b/gi, "")
      .replace(/\bBilly Cook\b/gi, "")
      .trim();
    return stripped || raw;
  };

  return (
    <>
      <div
        ref={ref}
        className={`cactus_card-container ${items?.length <= 3 ? "flex justify-center" : ""
          } w-full hide-scroll-bar`}
      >
        {!items?.length && !loading && (
          <p className="display_message">
            No saddles found. Please try adjusting your filter.
          </p>
        )}

        {items?.length > 0 && (
          <>
            {/* VARIANT cards */}


            {/* This needs to have different caples for Just Arrived,sale price ect.
          
          
          - Need to make dynamic caples for the different types of cards
          - Need to make the cards dynamic
          - Need to make the cards responsive\
        
          Just Arrived, Best Seller, Sale Price
          
          
          
          */


            }
            {/* {user && selectedHorse && ( */}
            {user  && (
              <div className="flex flex-wrap justify-center items-center  gap-[30px] py-10">
                {items
                  // ?.filter((item) => item.status !== "PERSONAL_PURCHASED")
                  ?.map((item, index) => (
                    <div
                      key={`saddle-card-${index}`}
                      className="saddle_cards_container"
                    >
                      {/* cart flags are computed inline where needed */}
                      <div className="flex gap-x-[16px] w-full">
                        {/* {index === 0 && (
                          <h1 className="cards_pill">Just Arrived</h1>
                        )} */}
                        <div className="w-full h-auto flex flex-col gap-y-2">
                          <div className="mt-2 flex flex-row gap-x-[41.24px] justify-between w-full  min-h-[67px]">
                            <div className="w-full flex flex-col">
                              <NavLink
                                to={manufacturerBrandPath(item?.brandName)}
                                className="text-[#5B7FB4] text-[14px] sm:text-[18px] font-semibold flex justify-between items-center leading-[110%] font-[Montserrat] cursor-pointer hover:underline"
                              >
                                {formatString(item?.brandName)}
                                <CactusSaddleIcon className="w-[20px] h-[20px] mr-[2px]" />
                              </NavLink>

                              <div onClick={() => onMoreDetailsClick(item, index)} className="font-[Montserrat] saddle_title min-h-[25px] font-[700] mt-[4px] overflow-hidden !text-[14px] sm:!text-[18px] hover:underline cursor-pointer transition-all duration-300">
                                {formatManufacturerTitle(item?.productTitle)}
                              </div>
                              <p className="font-[Montserrat] font-[700] text-[14px] mt-[8px] sm:!text-[18px]">
                                {`$${item?.price
                                  ?.toFixed(0)
                                  ?.replace(/\B(?=(\d{3})+(?!\d))/g, ",") ?? 0
                                  }`}
                              </p>
                            </div>
                            {(item?.size || item?.quantity !== undefined) && (
                              <div className="flex flex-col items-end gap-y-3">
                            {item?.size && (
                              <div className="flex flex-col items-center justify-center p-2 min-w-[73px] h-[48px] rounded-lg bg-[rgba(43,54,75,0.08)]">
                                    <p className="item_size !text-[10px]">SEAT SIZE:</p>
                                <div className="flex flex-row items-center gap-[4.67px]">
                                  <SeatSizeIcon />
                                  <p className="item_size">{`${item?.size}”`}</p>
                                </div>
                                  </div>
                                )}
                              </div>
                            )}
                          </div>
                          <div className="flex gap-x-[16px] w-full">
                            <div className="relative h-auto sm:h-[155px]">
                              <img
                                src={item?.photo}
                                alt={item?.photo ?? "cactus_saddle"}
                                className={
                                  // index === 0 ? "mt-[5px]" : ""
                                  ` w-[108.1px] h-auto sm:w-[173px] sm:h-[155px] rounded-lg object-cover`
                                }
                              />
                              <BrandImageOverlay
                                brandName={item?.brandName}
                                className="w-[30px] h-[20px] sm:w-[50px] sm:h-[26px] absolute bottom-[7px] left-[6px]"
                              />
                            </div>

                            {selectedHorseStatus === "LIVE" ? (
                              <div className="h-[155px] cactus_score_container">
                                <div className="cactus_saddlefit_score_text sm:block hidden !text-[14px]">
                                  Your SaddleFit Score
                                </div>
                                <div className="cactus_saddlefit_score_text block sm:hidden !text-[12px]">
                                  SaddleFit score
                                </div>
                                <div className="mt-[-20px]">
                                  <Gauge
                                    style={{
                                      width: size.width,
                                      height: size.height,
                                      fontFamily: "Montserrat",
                                      fontWeight: "bold",
                                    }}
                                    score={Math.round(item?.score ?? 0)}
                                  />
                                </div>
                              </div>
                            ) : (
                              <div className="cactus_score_container !w-[189px] sm:!w-[234px]">
                                <div className="cactus_saddlefit_score_text">
                                  What’s Your Saddle Fit Score?
                                </div>
                                <SelectHorseScore
                                  onClick={() => {
                                    if (!user) {
                                      setIsAction("selectBuyProduct");
                                      open(Modal.Login);
                                    }
                                  }}
                                  className="select_horse_score_img cursor-pointer"
                                />
                              </div>
                            )}
                          </div>
                          <div className="flex gap-x-2 w-full">
                            <div
                              onClick={() => onFavouriteClick(item, index)}
                              className={`heartBtn_cards_container !w-[40px] !h-[40px] cursor-pointer ${loadingFavorites[index] ? "loading" : ""
                                } ${favouriteSaddleList?.includes(item?.sk) &&
                                "!bg-[#2B364B]"
                                }`}
                            >
                              {loadingFavorites[index] ? (
                                <Loader
                                  loaderStyles="!w-5 !h-5 !flex !items-center !text-center !justify-center"
                                />
                              ) : favouriteSaddleList?.includes(item?.sk) ? (
                                <img src={heartwhite} alt="heart-white" />
                              ) : (
                                <img src={heart} alt="heart" />
                              )}
                            </div>
                            {(() => {
                              const isInCart = userCartData?.items?.some(
                                (ci) => (ci?.productData?.sk || ci?.saddleId || ci?.id) === item?.sk
                              );
                              const isAnyInCart = (userCartData?.items?.length || 0) > 0;
                              if (isInCart) {
                                return (
                                  <Button
                                    loading={removeCartLoading && loadingItemId === item?.sk}
                                    onClick={() => handleRemove(item?.sk)}
                                    className="find_score_add_to_cart w-[41%] sm:max-w-[182.6178px] sm:w-full !bg-[#C8403B]"
                                  >
                                    Remove From Cart
                                  </Button>
                                );
                              }
                              return (
                            <Button
                                  disabled={addToCartLoading === item?.sk || selectedHorseStatus === "PENDING" || (isAnyInCart && !isInCart)}
                              loading={addToCartLoading === item?.sk}
                              onClick={() => onAddToCartClick(item)}
                                  className="find_score_add_to_cart w-[41%] sm:max-w-[182.6178px] sm:w-full disabled:!bg-[#A3A3A3] disabled:!text-white disabled:opacity-100"
                            >
                              Add to Cart
                            </Button>
                              );
                            })()}
                            <Button
                              onClick={() => onMoreDetailsClick(item, index)}
                              className="find_score_more_details w-[41%] sm:max-w-[182.6178px] sm:w-full"
                            >
                              More details
                            </Button>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
            )}

            {/* PRODUCT cards */}
            {showGuestCarousel && (
              <Slider {...settings}>
                {items
                  ?.filter((item) => item.status !== "PERSONAL_PURCHASED")
                  ?.map((item, index) => (
                    <div key={index} className="carousel_cards_slider">
                      <div className="flex justify-between">
                        {/* {index === 0 && (
                          <h1 className="cards_pill">Just Arrived</h1>
                        )} */}
                        <img
                          src={item?.photo}
                          alt={item?.productTitle || "saddle"}
                          className={`${index === 0 ? "mt-[5px]" : ""
                            } w-[134.097px] h-auto cactus_saddle_image rounded-lg object-cover`}
                        />

                        <div className="cactus_text_container w-[204px] h-auto flex flex-col gap-y-2">
                          <div className="flex gap-x-2">
                            <div className="cactus_text w-[167px] flex flex-col gap-y-2">
                              <p className="cactus_card_title line-clamp-3">
                                {formatManufacturerTitle(item?.productTitle)}
                              </p>
                              <p className="cactus_card_price">{`$${item?.price
                                ?.toFixed(0)
                                ?.replace(/\B(?=(\d{3})+(?!\d))/g, ",") ||
                                3840
                                }`}</p>
                            </div>
                            {(item?.size || item?.quantity !== undefined) && (
                              <div className="flex flex-col items-end gap-1">
                            {item?.size && (
                              <div className="flex flex-col items-center justify-center  min-w-[73px] h-[48px] rounded-lg bg-[rgba(43,54,75,0.08)]">
                                    <p className="item_size !text-[10px]">SEAT SIZE:</p>
                                <div className="flex flex-row items-center gap-[4.67px]">
                                  <SeatSizeIcon />
                                  <p className="item_size">{`${item?.size}”`}</p>
                                </div>
                                  </div>
                                )}
                              </div>
                            )}
                          </div>
                          <div className="cactus_score_container">
                            <div className="cactus_saddlefit_score_text">
                              What’s Your Saddle Fit Score?
                            </div>
                            <SelectHorseScore
                              onClick={handleSelectHorse}
                              className="select_horse_score_img cursor-pointer"
                            />
                          </div>
                          <div className="!hidden sm:!flex">
                            <Button
                              onClick={() => unAuthDetailsClick(item)}
                              className="cactus_more_details !w-full !h-10"
                            >
                              More details
                            </Button>
                          </div>
                        </div>
                      </div>
                      <div className="mt-[14px] !flex sm:!hidden">
                        <Button
                          className="cactus_more_details !w-full !h-auto"
                          onClick={() => unAuthDetailsClick(item)}
                        >
                          More details
                        </Button>
                      </div>
                    </div>
                  ))}
              </Slider>
            )}
          </>
        )}
      </div >

      {actionState?.adding !== undefined && (
        <ShoppingCartModal
          isAdding={actionState.adding}
          description={
            !actionState.adding &&
            "The Saddle is already in your shopping cart."
          }
        />
      )}
    </>
  );
})

export default CarouselCards;
